import { createEntityAdapter } from '@reduxjs/toolkit'

import { Compartment } from './models/Compartment'

export const compartmentsAdapter = createEntityAdapter({
  selectId: (entity: Compartment) => entity.id,
})